import { useEffect } from 'react';

/**
 * Custom hook for synchronizing billing information with delivery information
 * @param {boolean} isSameInfo - Whether billing info should match delivery info
 * @param {object} cart - Cart object
 * @param {function} setCart - Function to update cart
 * @param {object} refs - Object containing refs for billing form inputs
 */
export const useBillingInfo = (isSameInfo, cart, setCart, refs) => {
	const { billingAddressRef, billingLastNameRef, billingFirstNameRef, billingPhoneRef } = refs;

	useEffect(() => {
		if (!isSameInfo) {
			if (billingAddressRef?.current) billingAddressRef.current.value = '';
			if (billingLastNameRef?.current) billingLastNameRef.current.value = '';
			if (billingFirstNameRef?.current) billingFirstNameRef.current.value = '';
			if (billingPhoneRef?.current) billingPhoneRef.current.value = '';

			setCart((prevState) => ({
				...prevState,
				billing_address: '',
				billing_lastname: '',
				billing_firstname: '',
				billing_phone: '',
			}));
			return;
		}

		if (!cart?.delivery_address?.address) return;

		if (billingAddressRef?.current) billingAddressRef.current.value = cart.delivery_address.address;
		if (billingLastNameRef?.current) billingLastNameRef.current.value = cart.delivery_lastname || '';
		if (billingFirstNameRef?.current) billingFirstNameRef.current.value = cart.delivery_firstname || '';
		if (billingPhoneRef?.current) billingPhoneRef.current.value = cart.delivery_phone || '';

		setCart((prevState) => ({
			...prevState,
			billing_address: cart.delivery_address.address,
			billing_lastname: cart.delivery_lastname || '',
			billing_firstname: cart.delivery_firstname || '',
			billing_phone: cart.delivery_phone || '',
		}));
	}, [isSameInfo, cart?.delivery_address, cart?.delivery_lastname, cart?.delivery_firstname, cart?.delivery_phone, setCart, billingAddressRef, billingLastNameRef, billingFirstNameRef, billingPhoneRef]);
};

